import index from "./groupConfig.vue";
export default index;
